const primaryMain = '#990000';
const primaryMainOpacity = 'rgba(153, 0, 0, 0.9)';
const secondaryMain = '#02324F';
const secondaryMainOpacity = 'rgba(2, 50, 79, 0.5)';
const secondaryLight = '#0B486D';
const tertiaryMain = '#02324F';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain
};
